import {
  DESKTOP_MEDIA_QUERY,
  DRAGGABLE_Y_SCROLL_SELECTOR,
  defaultConfig,
} from "./constants";
import { mountVerticalTimelineInstance } from "./mountVerticalTimelineInstance";

let timelineInstanceCleanups = [];
let hasInitialisedLifecycleListeners = false;

export const cleanupDraggableVerticalScroll = () => {
  timelineInstanceCleanups.forEach((cleanup) => cleanup());
  timelineInstanceCleanups = [];
};

export const setupDraggableVerticalScroll = ({
  doc = document,
  win = window,
  config = {},
} = {}) => {
  const mergedConfig = { ...defaultConfig, ...config };

  cleanupDraggableVerticalScroll();

  doc.querySelectorAll(DRAGGABLE_Y_SCROLL_SELECTOR).forEach((element) => {
    const cleanup = mountVerticalTimelineInstance({
      element,
      doc,
      win,
      config: mergedConfig,
    });

    timelineInstanceCleanups.push(cleanup);
  });
};

export const initialiseVerticalTimelineItems = () => {
  if (hasInitialisedLifecycleListeners) {
    return;
  }

  hasInitialisedLifecycleListeners = true;

  const applySetup = () => setupDraggableVerticalScroll();
  const desktopQueryList = window.matchMedia(DESKTOP_MEDIA_QUERY);
  const handleViewportChange = () => applySetup();

  document.addEventListener("DOMContentLoaded", applySetup);
  document.addEventListener("turbo:load", applySetup);
  document.addEventListener(
    "turbo:before-cache",
    cleanupDraggableVerticalScroll
  );
  desktopQueryList.addEventListener("change", handleViewportChange);
};
